// client/src/services/lexistarFuel.js
//
// LexiStar fuel configuration API client (ST-00188 M2-A1; contracts m2 §4.1):
// consumption norms, diesel prices and rate cards, all effective-dated.
// Server: server/modules/lexistar/fuel (/api/lexistar/fuel/*).
//
// POST opens a period for a key; PATCH closes the row in force and opens a new
// one from effective_from (default now) — past rows never change. Every
// helper resolves to the response BODY; payloads use migration 025's column
// names. Litres are the unit of record (D21).

import api from './api';

const BASE = '/lexistar/fuel';

const clean = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
  );

const body = (res) => res.data;

/** { norms: [{ id, scope, vehicle_class, asset_id, asset_registration, load_state, l_per_100km, idle_lph, route_factor, effective_from, effective_to, status }] } */
export const listNorms = (params) => api.get(`${BASE}/norms`, { params: clean(params) }).then(body);

/** { norm } — 409 { conflictingId } when a norm for the key is already in force. */
export const createNorm = (data) => api.post(`${BASE}/norms`, data).then(body);

/** { closed, opened } */
export const changeNorm = (id, data) => api.patch(`${BASE}/norms/${id}`, data).then(body);

/** { prices: [{ id, region, price_per_l, effective_from, effective_to, status }] } */
export const listPrices = (params) =>
  api.get(`${BASE}/prices`, { params: clean(params) }).then(body);

export const createPrice = (data) => api.post(`${BASE}/prices`, data).then(body);

export const changePrice = (id, data) => api.patch(`${BASE}/prices/${id}`, data).then(body);

/** { rate_cards: [{ id, vehicle_class, rate_per_km, driver_rate_per_h, toll_class, effective_from, effective_to, status }] } */
export const listRateCards = (params) =>
  api.get(`${BASE}/rate-cards`, { params: clean(params) }).then(body);

export const createRateCard = (data) => api.post(`${BASE}/rate-cards`, data).then(body);

export const changeRateCard = (id, data) => api.patch(`${BASE}/rate-cards/${id}`, data).then(body);

/** { vehicle_classes: string[] } — classes in use plus 'truck'. */
export const listVehicleClasses = () => api.get(`${BASE}/vehicle-classes`).then(body);
